import http from './http';

const ENDPOINTS = {
  // Reports endpoints
  REPORTS: '/api/v1/reports',
  ALL_STATS: '/api/v1/reports/all-stats',
  PATIENT_REPORTS: '/api/v1/reports/patient',
  DOCTOR_REPORTS: '/api/v1/reports/doctor',
  APPOINTMENT_REPORTS: '/api/v1/reports/appointments',
  FINANCIAL_REPORTS: '/api/v1/reports/financial',
  CENSUS_REPORTS: '/api/v1/reports/census',
  QUALITY_REPORTS: '/api/v1/reports/quality',
  CUSTOM_REPORTS: '/api/v1/reports/custom',
  EXPORT_REPORT: (type) => `/api/v1/reports/export/${type}`,
};

/**
 * Reports API Service
 */
export const reportsAPI = {
  /**
   * Get dashboard summary reports with comprehensive stats
   */
  getDashboardSummary: async (params = {}) => {
    const response = await http.get(ENDPOINTS.ALL_STATS, { params });
    return response.data;
  },

  /**
   * Get patient-related reports
   */
  getPatientReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.PATIENT_REPORTS, { params });
    return response.data;
  },

  /**
   * Get doctor-related reports
   */
  getDoctorReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.DOCTOR_REPORTS, { params });
    return response.data;
  },

  /**
   * Get appointment reports
   */
  getAppointmentReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.APPOINTMENT_REPORTS, { params });
    return response.data;
  },

  /**
   * Get financial reports
   */
  getFinancialReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.FINANCIAL_REPORTS, { params });
    return response.data;
  },

  /**
   * Get census reports (patient admission/discharge statistics)
   */
  getCensusReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.CENSUS_REPORTS, { params });
    return response.data;
  },

  /**
   * Get quality metrics reports
   */
  getQualityReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.QUALITY_REPORTS, { params });
    return response.data;
  },

  /**
   * Get custom reports
   */
  getCustomReports: async (params = {}) => {
    const response = await http.get(ENDPOINTS.CUSTOM_REPORTS, { params });
    return response.data;
  },

  /**
   * Export report in specified format
   */
  exportReport: async (type, params = {}) => {
    const response = await http.get(ENDPOINTS.EXPORT_REPORT(type), { 
      params,
      responseType: 'blob'
    });
    return response.data;
  }
};

export default reportsAPI;